import { motion } from 'motion/react';
import { AppIcon } from '../app/AppIcon.js';
import { useUpdateStore } from './useUpdate.js';

/**
 * "There is a new version" as a control, not a message.
 *
 * The banner explains and can be dismissed; this stays. Someone who postponed
 * an update still needs a way back to it, and a dismissed strip leaves them
 * with none — the only route left is a reload they have to think of
 * themselves.
 *
 * Absent when there is nothing to install. An icon that is always there,
 * greyed, teaches people to stop seeing it, and then it is not there on the
 * day it matters.
 */

const EASE_SWIM = [0.16, 1, 0.3, 1] as const;

export function UpdateBadge() {
  const urgency = useUpdateStore((s) => s.urgency);
  const apply = useUpdateStore((s) => s.apply);
  const deferredReason = useUpdateStore((s) => s.deferredReason);

  if (urgency === 'none') return null;

  // A required update is not a suggestion, so it says so and pulses. Anything
  // else is offered quietly.
  const required = urgency === 'required';

  return (
    <motion.button
      className="update-badge"
      data-required={required}
      onClick={() => apply(required)}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.32, ease: EASE_SWIM }}
      title={
        deferredReason !== null
          ? 'Güncelleme hazır — işin bitince uygulanacak, şimdi uygulamak için tıkla'
          : required
            ? 'Zorunlu güncelleme — tıkla ve yeniden başlat'
            : 'Güncelleme hazır — tıkla ve yeniden başlat'
      }
      aria-label="Güncellemeyi uygula"
    >
      <AppIcon name="refresh" size={15} hole="transparent" />
      <span className="update-badge-dot" />
    </motion.button>
  );
}
